import React from 'react';

import { SiteNav } from '../../components/SiteNav/SiteNav';
import { useInView } from '../../hooks/useInView';
import type { RosterHeader } from './types';

export function RosterHeaderSection({ data }: { data: RosterHeader }) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="roster-header">
            <div className="roster-header__nav">
                <SiteNav />
            </div>
            <div
                ref={ref}
                className={`roster-header__content faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
            >
                <p className="roster-header__eyebrow faves-eyebrow faves-reveal">{data.eyebrow}</p>
                <h1
                    className="roster-header__heading faves-display faves-reveal"
                    style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                >
                    {data.heading}
                </h1>
            </div>
        </section>
    );
}
